var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommendations"},[_c('div',{staticClass:"recommendations__title"},[_vm._v("Полезное для вас")]),_c('div',{staticClass:"recommendations__row"},_vm._l((_vm.NewRecommendations),function(item,ind){return _c('RecMaterial',{key:ind,attrs:{"item":item,"hideImage":true,"hideFavorites":true},on:{"recClick":_vm.recClick}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }